export function readmoreInit() {
    // $('.companies-listing .read-more-container').readmore({
    //     speed: 300,
    //     collapsedHeight: 115,
    //     moreLink: '<a href="#" style="font-size: 32px;line-height: 0.8;margin-top: -10px;">...</a>',
    //     lessLink: '<a href="#"></a>',
    //     heightMargin: 16
    // });

    let ellipsestext = "...";
    let $selector = $('.companies-listing .read-more-container');
    if ($selector.length) {
        $selector.each(function () {
            let $showChar = 80;
            let $firstTag = $(this).children(":first");
            let $content = $firstTag.html();
            if ($firstTag.length) {
                if ($content.length > $showChar) {
                    let c = $content.substr(0, $showChar);
                    let h = $content.substr($showChar, $content.length - $showChar);

                    let html = c + '<span class="morecontent">' + h + '</span><span class="morecontent_container"><a href="" class="morelink-btn">...</a></span>';

                    $firstTag.html(html);
                }
                $(this).children().not(":eq(0)").wrapAll('<div class="hiden-wrap" />');
            }

        })

    }

    $(document).on('click','.morelink-btn', function (e) {
        e.preventDefault();
        $(this).hide().parents('.read-more-container').addClass('open')
    })

}


// WEBPACK FOOTER //
// ./assets/js/modules/readmoreCustom.js